import {inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformServer} from '@angular/common';
import {CookieService} from 'ngx-cookie-service';
import {UIStorageService} from '../../oex-ui-kit/services/storage.service';

@Injectable({
  providedIn: 'root'
})
export class StorageService extends UIStorageService {
  private cookies = inject(CookieService);
  private ssrCookies = inject(Request, { optional: true })?.headers.get('cookie') || '';
  private platformId = inject(PLATFORM_ID);

  public set(key: string, value: any) {
    if (isPlatformServer(this.platformId)) {
      return;
    }
    this.cookies.set(key, value + '', 30, '/');
  }

  public get(key: string) {
    if (isPlatformServer(this.platformId)) {
      if (!this.ssrCookies) {
        return '';
      }
      return this.getCookie(key, this.ssrCookies) ?? '';
    } else {
      return this.cookies.get(key);
    }
  }

  public remove(key: string) {
    if (isPlatformServer(this.platformId)) {
      return;
    }
    this.cookies.delete(key, '/');
  }

  private getCookie(name: string, cookies: string) {
    const value = `; ${cookies}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift();
    return '';
  }
}
